import React from 'react'
import Page from '../Page'

const DC = ({ testResult }) => {
  return (
    <>
      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری DC تسلط بالا همراه با قانون‌گرایی"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری   DCترکیبی از اراده بالا، نیاز به کنترل، تصمیم‌گیری قاطع و در عین حال دقت و پایبندی به اصول و قوانین را در خود دارند. این افراد معمولاً با رویکردی منطقی، ساختارمند و هدفمند به مسائل نگاه می‌کنند. آن‌ها می‌خواهند هم سریع و قوی عمل کنند، هم دقیق و بدون خطا.
        </p>
        <p className="text-gray-800 leading-7">
          در واقع،  DCها هم می‌خواهند در سریع‌ترین زمان ممکن به نتیجه برسند، هم مطمئن شوند که همه‌چیز طبق استاندارد پیش رفته است. این دو بعد گاهی آن‌ها را به چالش می‌کشند؛ چون باید بین سرعت عمل D  و دقت و تحلیل C  تعادل برقرار کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های کلیدی افراد DC :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تصمیم‌گیرانی سریع اما با تحلیل پشت‌صحنه.</li>
          <li>هدف‌گرا، با استانداردهای بالا برای خود و دیگران.</li>
          <li>خلاق در حل مسائل و علاقمند به کنترل فرایندها.</li>
          <li>کمال‌گرا و پیگیر برای انجام کارها به بهترین نحو.</li>
          <li>معمولاً سرد، رسمی و دقیق در ارتباط با دیگران.</li>
          <li>حساس نسبت به کاهش تأثیرگذاری، و ترس از اشتباه یا شکست.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="در محیط کار:"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCمعمولاً مدیرانی مقتدر، دقیق، و پرتوقع هستند. آن‌ها کارهای سطحی یا غیرحرفه‌ای را نمی‌پذیرند و انتظارات بالایی از تیم خود دارند. تصمیمات مهم را پس از بررسی دقیق می‌گیرند و برای اجرایشان، سرعت و اقتدار لازم را به خرج می‌دهند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت DC:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تمرکز بالا روی هدف، منطق و نتیجه‌گرایی.</li>
          <li>توان حل مسئله در شرایط پیچیده.</li>
          <li>ترکیب تفکر تحلیلی و رهبری اجرایی.</li>
          <li>قابلیت هدایت تیم یا پروژه با استانداردهای بالا.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های شخصیتی:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>کمال‌گرایی افراطی که ممکن است باعث فرسودگی یا خستگی اطرافیان شود.</li>
          <li>تمایل به کنترل بیش از حد دیگران.</li>
          <li>سخت‌گیری نسبت به خود و دیگران.</li>
          <li>بی‌توجهی به روابط انسانی و احساسی در تعاملات.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          تصور کنید در یک پروژه‌ی استارتاپی، مدیر پروژه‌ای داریم با الگوی  DC. او ابتدا با تحقیقات دقیق تمام سناریوهای ممکن را تحلیل می‌کند، سپس تصمیم می‌گیرد با سرعت بالا وارد بازار شود. اگر تیم طبق استاندارد او عمل نکند، ممکن است به شدت انتقاد کند یا حتی خودش وارد عمل شود. ولی وقتی با تیمی حرفه‌ای و هماهنگ باشد، می‌تواند تحولی جدی و ماندگار ایجاد کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Moneyball" 2011
          داستان مدیری با تفکر تحلیلی و استراتژیک که در کنار تسلط بر شرایط، با داده‌ها و منطق تصمیم می‌گیرد تا تیم بیسبال خود را متحول کند. شخصیتی بسیار نزدیک به  DC .
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی DC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای تیپ رفتاری   DCدر واقع ترکیبی از دو بُعد بسیار تأثیرگذار هستند:
          تسلط Dominance  که به دنبال قدرت، نتیجه‌گرایی، و کنترل موقعیت است، و
          وجدان Conscientiousness  که تمرکز بر دقت، تحلیل، رعایت اصول و استانداردها دارد.
        </p>
        <p className="text-gray-800 leading-7">
          این ترکیب باعث می‌شود شخصیت فرد   DCهم رهبر باشد، هم تحلیل‌گر. کسی که هم برای رسیدن به نتیجه عجله دارد، و هم حاضر نیست کوچک‌ترین خطایی را بپذیرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشخصه‌های کلیدی افراد DC:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. عملگرا و هدف‌محور</h3>
        <p className="text-gray-800 leading-7">
          همه چیز باید به سمت هدف مشخص پیش برود. افراد   DCحوصله حاشیه‌سازی، بی‌نظمی یا مسیرهای گنگ را ندارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. استانداردگرا و اصول‌محور</h3>
        <p className="text-gray-800 leading-7">
          به‌شدت به قوانین، رویه‌ها و کیفیت اهمیت می‌دهند. در کار با آن‌ها، بی‌دقتی یک گناه نابخشودنی است!
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تحلیل‌گر ولی سریع‌العمل</h3>
        <p className="text-gray-800 leading-7">
          برخلاف افراد صرفاً C، آن‌ها نمی‌مانند در تحلیل؛ پس از تحلیل، قاطعانه عمل می‌کنند. به قول معروف: با دقت تصمیم می‌گیرند، با سرعت اجرا می‌کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشخصه‌های کلیدی افراد DC:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. کنترل‌گر و مقتدر</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها دوست دارند همه‌چیز زیر نظرشان باشد. نه به خاطر عدم اعتماد، بلکه چون باور دارند روش خودشان منطقی‌تر و مؤثرتر است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. مستقل و خوداتکا</h3>
        <p className="text-gray-800 leading-7">
          کمتر دنبال کمک گرفتن از دیگران هستند. وقتی کاری را برعهده می‌گیرند، ترجیح می‌دهند خودشان آن را تا انتها مدیریت کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. کم‌احساس و رسمی در تعاملات</h3>
        <p className="text-gray-800 leading-7">
          ممکن است خیلی اهل شوخی یا ابراز احساسات نباشند. ارتباطشان بیشتر هدف‌محور و نتیجه‌گراست.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="در محیط کاری:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>ترجیح می‌دهند مسئول پروژه، مدیر یا مشاور اصلی باشند.</li>
          <li>معمولاً در پروژه‌هایی که نیاز به ساختار، تحلیل عمیق و سرعت اجرا دارد می‌درخشند.</li>
          <li>اگر تیمی ضعیف یا پر از ابهام در اختیارشان باشد، یا خودشان را جدا می‌کنند یا همه‌چیز را به دست می‌گیرند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار آن‌ها در مواجهه با دیگران:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>از افراد کند، احساساتی یا بی‌برنامه خسته می‌شوند.</li>
          <li>به همکارانی که اهل تحلیل، سرعت عمل، و تفکر منطقی باشند، احترام زیادی می‌گذارند.</li>
          <li>اگر کسی کار را ناقص انجام دهد، یا بدون منطق نظر دهد، واکنش آن‌ها صریح، گاهی تند، اما با هدف اصلاح خواهد بود.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های احتمالی:"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">خشکی در روابط</h4>
            <p>
              ممکن است به دلیل تأکید زیاد بر منطق و ساختار، روابط انسانی را تضعیف کنند.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">کمال‌گرایی مفرط</h4>
            <p>
              هیچ‌چیزی به اندازه "نقص" یا "بی‌نظمی" آن‌ها را اذیت نمی‌کند.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">مشکل در تفویض اختیار</h4>
            <p>
              گاهی کارها را زیاد از حد کنترل می‌کنند و نمی‌گذارند دیگران مستقل عمل کنند.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="یک تصویر ذهنی:"
      >
        <p className="text-gray-800 leading-7">
          شخصیت   DCرا می‌توان مثل مدیر سخت‌گیر و منضبط یک کارخانه دید که هم روی تولید و هم روی فرآیند حسابداری، شخصاً نظارت می‌کند. او اهل تعارف نیست، ولی اگر تیمش حرفه‌ای باشد، رشد خارق‌العاده‌ای خواهد داشت.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری DC"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری   DCترکیبی نادر از دو قدرت بزرگ رفتاری هستند:
          اراده بالا برای تسلط D  و نیاز درونی برای دقت و کنترل کیفیت C .
          آن‌ها به‌نوعی «رهبران تحلیلی» هستند؛ کسانی که وقتی وارد کاری می‌شوند، می‌خواهند هم مسلط باشند و هم درست و بی‌نقص عمل کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه‌های افراد با الگوی رفتاری DC"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCبا ترکیب دو نیروی پرقدرت در رفتارشان تسلط D  و دقت C برای حرکت و تلاش در زندگی، نیاز به انگیزه‌هایی دارند که هم احساس قدرت به آن‌ها بدهد و هم ارزش‌های عقلانی و منطقی‌شان را ارضا کند.
        </p>
        <p className="text-gray-800 leading-7">
          به بیان ساده‌تر، این افراد زمانی انگیزه می‌گیرند که هم بتوانند کنترل امور را به دست بگیرند و هم مطمئن شوند کاری که می‌کنند کاملاً درست و بی‌نقص است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عوامل انگیزشی کلیدی در افراد DC:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. قدرت و کنترل</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها دوست دارند مسئولیت امور را بر عهده داشته باشند و تصمیم‌گیرنده نهایی باشند. وقتی حس کنند روی موقعیت تسلط دارند، انگیزه‌شان شکوفا می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دستیابی به نتایج دقیق و استاندارد بالا</h3>
        <p className="text-gray-800 leading-7">
          موفقیت فقط رسیدن به هدف نیست، بلکه رسیدن به آن با بالاترین کیفیت و کمترین خطاست.
          انگیزه آن‌ها در “نتیجه با کیفیت بالا” نهفته است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عوامل انگیزشی کلیدی در افراد DC:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. استقلال در فکر و عمل</h3>
        <p className="text-gray-800 leading-7">
          اگر احساس کنند به آن‌ها آزادی در تصمیم‌گیری و تحلیل داده‌ها داده شده، با تمام وجود درگیر می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. ارزیابی منطقی و عادلانه عملکردشان</h3>
        <p className="text-gray-800 leading-7">
          DCها به بازخوردهای احساسی یا مبهم واکنش خوبی نشان نمی‌دهند. اما اگر تحلیل دقیق عملکردشان به آن‌ها نشان دهد که در مسیر درست هستند، انگیزه‌شان افزایش می‌یابد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عوامل انگیزشی کلیدی در افراد DC:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. فرصت برای حل مسائل پیچیده</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها عاشق چالش‌های تحلیلی هستند. حل یک مسئله فنی، طراحی یک سیستم بهتر یا حل یک بن‌بست سازمانی برایشان بسیار هیجان‌انگیز است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. فرصت برای برتری و پیشرفت شخصی</h3>
        <p className="text-gray-800 leading-7">
          میل به رشد و پیشرفت دائمی در درونشان نهادینه شده. انگیزه آن‌ها زمانی اوج می‌گیرد که بدانند کاری که می‌کنند آن‌ها را از بقیه متمایز می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار آن‌ها وقتی انگیزه دارند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تمرکز بالا، پیگیری بی‌وقفه، اجرای بی‌نقص</li>
          <li>مدیریت قاطع تیم یا پروژه</li>
          <li>ارائه تحلیل‌های عمیق و اجرای راه‌حل‌های ساختاریافته</li>
          <li>سخت‌گیری بیشتر روی کیفیت و نظم</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="وقتی انگیزه ندارند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>دچار بی‌حوصلگی، بی‌اعتمادی به تیم یا سیستم</li>
          <li>عقب‌نشینی و سکوت یا انتقادهای شدید از دیگران</li>
          <li>تمرکز بیش از حد روی جزئیات به‌جای اقدام</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فردی با تیپ   DCزمانی به‌شدت انگیزه‌مند می‌شود که در یک شرکت، مدیریت پروژه‌ای بحرانی را به او می‌سپارند و در عین حال دستش را باز می‌گذارند تا روش اجرای پروژه را خودش طراحی کند. این «اعتماد + مسئولیت کلیدی» برای او یعنی حداکثر انگیزه.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          The Imitation Game 2014  بازی تقلید
          سکانس هایی از شخصیت "آلن تورینگ" نمونه‌ای از تیپ   DCاست که هم میل به حل معمای پیچیده دارد و هم علاقه به نظم، کنترل، و اجرای بدون نقص. تماشای این فیلم درک خوبی از انگیزه‌های درونی افراد   DCمی‌دهد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ DC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای تیپ   DCدر محیط کاری، تلفیقی از سرعت عمل هدفمند D  و دقت، نظم و تحلیل عمیق C  را با خود به همراه دارند. آن‌ها در هر محیطی که نیاز به ساختار قوی، تصمیم‌گیری سریع و کنترل دقیق وجود داشته باشد، می‌درخشند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. برنامه‌ریزی ساختارمند اما انعطاف‌ناپذیر</h3>
        <p className="text-gray-800 leading-7">
          DCها معمولاً همه‌چیز را با جزئیات برنامه‌ریزی می‌کنند. آن‌ها عاشق داشتن چک‌لیست، تایم‌لاین دقیق، و نقشه راه هستند.
          اما نکته اینجاست که گاهی اگر چیزی از این برنامه عقب بیفتد، ممکن است عصبی شوند یا فشار زیادی بر تیم وارد کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تمرکز شدید روی کیفیت و خروجی نهایی</h3>
        <p className="text-gray-800 leading-7">
          برای یک  DC، صرفاً انجام دادن یک کار کافی نیست؛ باید بهترین خروجی ممکن حاصل شود. آن‌ها از همکارانی که کار «سرهم‌بندی» تحویل می‌دهند ناراضی‌اند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تمایل به اجرای مستقل وظایف</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها ترجیح می‌دهند پروژه‌ای را خودشان طراحی، هدایت و ارزیابی کنند. اگر هم مجبور به همکاری باشند، می‌خواهند در جایگاه رهبر تحلیل‌گر تیم قرار گیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. احساس مسئولیت بالا، گاهی افراطی</h3>
        <p className="text-gray-800 leading-7">
          DCها اگر مسئولیت کاری را بپذیرند، تا آخرین لحظه برای انجام درست آن می‌جنگند. حتی ممکن است کار دیگران را نیز خودشان انجام دهند تا استاندارد مورد نظرشان رعایت شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. عدم مدارا با بی‌نظمی و ابهام</h3>
        <p className="text-gray-800 leading-7">
          اگر فضای کاری یا اطلاعات پروژه ناقص، مبهم یا بی‌ساختار باشد، فرد   DCدچار بی‌قراری شدید می‌شود و ممکن است یا خودش ساختار ایجاد کند، یا از آن محیط فاصله بگیرد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. تمایل به ارزیابی و بازبینی مستمر</h3>
        <p className="text-gray-800 leading-7">
          یکی از عادت‌های رایج آن‌ها مرور و اصلاح فرآیندها، گزارش‌گیری مداوم، و یافتن راه‌های بهبود است. آن‌ها سیستم‌ها را بارها تحلیل می‌کنند تا مطمئن شوند همه‌چیز دقیق کار می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. نیاز به کنترل روی اعضای تیم</h3>
        <p className="text-gray-800 leading-7">
          در کارهای گروهی،  DCها دوست دارند بدانند هر کس دقیقاً چه کاری انجام می‌دهد، چرا، و با چه کیفیتی. این نیاز به کنترل گاهی باعث فشار روی دیگران می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. عمل‌گرا با پشتوانه تحلیلی</h3>
        <p className="text-gray-800 leading-7">
          یک ویژگی منحصربه‌فرد در عادات کاری   DCاین است که:
          «فقط اهل فکر نیست، بلکه بلافاصله وارد عمل هم می‌شود.»
          برخلاف تیپ C  که ممکن است در تحلیل زیاد بماند،   DC بلافاصله بعد از تحلیل وارد اجرا می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          در یک سازمان فناوری، فرد   DCمسئول توسعه سیستم مدیریت منابع انسانی است. او ابتدا ساختار کامل سیستم را تحلیل می‌کند، سپس استانداردهای امنیت و دقت اطلاعات را تعریف می‌کند و بعد تیم را وادار به اجرای دقیق آن می‌کند. اگر کسی کار را ناقص یا بی‌برنامه انجام دهد، فوراً مداخله می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Ford v Ferrari" 2019
          شخصیت "کن مایلز" به‌نوعی نماینده یک   DCدر عمل است؛ کسی که هم نظم، هم مهندسی دقیق، و هم اراده بالا برای بردن را دارد. فیلمی عالی برای درک عادت‌های کاری چنین تیپ رفتاری.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های افراد با الگوی رفتاری DC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای تیپ رفتاری  DC، دنیا را از دریچه‌ای می‌بینند که در آن قانون، منطق، ساختار و کنترل محورهای اصلی‌اند. نگاه آن‌ها به زندگی، کار، انسان‌ها و موقعیت‌ها عمیقاً تحلیلی و نتیجه‌گراست. در عین حال، آن‌ها به‌شدت بر این باورند که «اگر قرار است کاری انجام شود، باید درست، سریع و با بالاترین کیفیت ممکن انجام شود.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های افراد با الگوی رفتاری DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. دیدگاه نسبت به کار: "کیفیت، کنترل، نتیجه"</h3>
        <p className="text-gray-800 leading-7">
          DCها کار را نه فقط برای انجام وظیفه، بلکه برای رسیدن به نتیجه‌ای مشخص با استاندارد بالا می‌خواهند. آن‌ها به‌سختی با محیط‌هایی که در آن‌ها اولویت با کمیت، سطحی‌نگری یا سرعت بدون کیفیت است، کنار می‌آیند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دیدگاه نسبت به افراد: "شایستگی، منطق، تعهد"</h3>
        <p className="text-gray-800 leading-7">
          در نگاه آن‌ها، افراد باید شایسته، منطقی، بااخلاق و مسئولیت‌پذیر باشند.
          از کسانی که کار را سرسری انجام دهند، احساساتی تصمیم بگیرند یا از زیر بار مسئولیت شانه خالی کنند، به‌شدت دلزده می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. دیدگاه نسبت به تصمیم‌گیری: "داده محور و بدون احساس‌گرایی"</h3>
        <p className="text-gray-800 leading-7">
          DCها معتقدند تصمیم خوب، تصمیمی است که بر پایه‌ی اطلاعات دقیق، تحلیل منطقی و سناریوهای واضح گرفته شده باشد.
          در جلسات تصمیم‌گیری، آن‌ها معمولاً اولین کسانی هستند که از جملاتی مثل:
          «بیایید ببینیم اعداد چه می‌گویند» یا «چه شواهدی برای این تصمیم داریم؟» استفاده می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. دیدگاه نسبت به رهبری: "رهبر کسی است که هم می‌فهمد، هم می‌برد"</h3>
        <p className="text-gray-800 leading-7">
          از نظر آن‌ها، یک مدیر یا رهبر باید هم درک تحلیلی بالا داشته باشد و هم بتواند تیم را به‌سمت نتیجه حرکت دهد. رهبری بدون برنامه یا بدون تسلط واقعی را جدی نمی‌گیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. دیدگاه نسبت به تغییر: "تغییر باید توجیه‌پذیر و منطقی باشد"</h3>
        <p className="text-gray-800 leading-7">
          برخلاف تیپ‌های I  یا S  که گاهی تغییر را به‌خاطر تنوع یا همراهی با جمع می‌پذیرند،  DCها فقط زمانی با تغییر موافقند که:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>توجیه منطقی داشته باشد</li>
          <li>موجب بهبود قابل سنجش شود</li>
          <li>فرآیند جایگزین بهتر از قبل طراحی شده باشد</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های افراد با الگوی رفتاری DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. نگاه به موفقیت شخصی: "موفقیت یعنی کنترل، دقت، و نتیجه ماندگار"</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها موفقیت را نه فقط در داشتن مقام یا پول، بلکه در کنترل دقیق مسیر، دستیابی به اهداف بلندمدت و حفظ اعتبار حرفه‌ای می‌دانند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. نگاه به زمان: "منابع محدود، باید حداکثر بهره‌وری را داشت"</h3>
        <p className="text-gray-800 leading-7">
          زمان برای  DCها مقدس است. از اتلاف وقت، جلسات بی‌هدف، یا کارهای بدون اولویت عمیقاً بیزارند. هر لحظه‌ای که صرف کاری بی‌نتیجه شود، از نظر آن‌ها نوعی شکست است.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          در یک جلسه تیمی، وقتی اعضا به صورت احساسی درباره حذف یا ادامه یک پروژه بحث می‌کنند، فرد   DCوارد می‌شود، داده‌ها را روی میز می‌گذارد، روند سود و زیان را تحلیل می‌کند و می‌گوید:
          «بیایید با عدد و تحلیل تصمیم بگیریم، نه با حدس و گمان.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "The Social Network" 2010
          شخصیت مارک زاکربرگ در این فیلم، نشانه هایی از نگاه   DCدارد: کنترل، تحلیل‌گری، عدم توجه به احساسات در مسیر رسیدن به هدف، و تکیه بر منطق و ساختار برای تصمیم‌گیری.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ DC"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری   DCحتی در زمان استراحت نیز به دنبال نظم، هدفمندی، یادگیری، و کیفیت بالا هستند. اوقات فراغت آن‌ها غالباً آرام، ساختارمند، و گاه با هدف بهبود مهارت یا تسلط بیشتر بر موضوع خاصی سپری می‌شود. برای آن‌ها استراحت صرف، بدون هدف یا برنامه، معمولاً کسل‌کننده و بی‌معناست.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. فعالیت‌های تحلیلی و هوشمندانه</h3>
        <p className="text-gray-800 leading-7">
          افراد   DCاز وقت‌گذرانی‌هایی مثل حل معما، شطرنج، بازی‌های استراتژیک، مطالعه‌ تحلیل‌های اقتصادی یا مستندهای علمی لذت می‌برند. این فعالیت‌ها هم به ذهن نظم می‌دهند، هم هیجان درونی تحلیل و کنترل را زنده نگه می‌دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. مطالعه هدفمند و یادگیری پیوسته</h3>
        <p className="text-gray-800 leading-7">
          کتاب‌هایی درباره رهبری، ساختار سازمانی، مدیریت بحران، استراتژی یا بیوگرافی رهبران موفق، انتخاب‌های محبوب این افراد است. حتی در تفریح هم به دنبال رشد فکری‌اند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ورزش‌هایی با ساختار یا رقابت مشخص</h3>
        <p className="text-gray-800 leading-7">
          ورزش‌های فردی و هدف‌مند مانند بدنسازی، تیراندازی، تنیس یا دوچرخه‌سواری انتخاب‌های خوبی هستند. در این ورزش‌ها افراد   DCمی‌توانند هم کنترل داشته باشند، هم رقابت، و هم پیشرفت را به‌صورت عددی اندازه‌گیری کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. سفرهای با برنامه‌ریزی دقیق</h3>
        <p className="text-gray-800 leading-7">
          سفر بدون هدف یا بدون برنامه‌ریزی آن‌ها را خسته می‌کند. آن‌ها دوست دارند مقصد، مسیر، هزینه، و حتی برنامه‌های روزانه سفر از قبل مشخص باشد. سفر آموزشی یا حرفه‌ای بیشتر برایشان جذاب است تا سفر تفریحی بی‌برنامه.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تنهایی ارزشمند یا همراهی با افراد باهوش</h3>
        <p className="text-gray-800 leading-7">
          ترجیح می‌دهند در اوقات فراغت با کسانی وقت بگذرانند که گفت‌وگو با آن‌ها ارزش ذهنی دارد. از معاشرت‌های سطحی و بی‌هدف معمولاً پرهیز می‌کنند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فردی با تیپ   DCممکن است یک عصر جمعه را به تماشای مستندی درباره «ساختار نظام اقتصادی چین» اختصاص دهد، سپس تمرینات بدنسازی انجام دهد و شب را به برنامه‌ریزی مالی شخصی خود برای شش ماه آینده اختصاص دهد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "The Big Short" 2015
          روایتی از بحران اقتصادی ۲۰۰۸ با تمرکز بر تحلیل‌گران دقیق و قاطع. فیلمی جذاب برای تیپ‌های   DCکه عاشق تحلیل، عدد، کنترل و پشت‌پرده مسائل هستند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در افراد با الگوی رفتاری DC"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCترکیبی از سرعت تصمیم‌گیری ویژگی تیپ D  و دقت در تحلیل و بررسی جزئیات ویژگی تیپ C  را دارند. همین ویژگی باعث می‌شود تصمیمات آن‌ها همواره هدفمند، سنجیده، قاطع و منطقی باشد. آن‌ها از تصمیم‌گیری نمی‌ترسند، اما هرگز عجولانه یا احساسی تصمیم نمی‌گیرند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های تصمیم‌گیری در DCها:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تحلیل دقیق قبل از اقدام</h3>
        <p className="text-gray-800 leading-7">
          پیش از هر تصمیم،   DCبه دنبال داده، آمار، سابقه و شواهد می‌گردد. تصمیم بدون اطلاعات برایشان بی‌معنی است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تصمیم‌گیری سریع پس از اطمینان از صحت تحلیل</h3>
        <p className="text-gray-800 leading-7">
          به‌محض اینکه از اعتبار تحلیل و داده‌ها مطمئن شوند، بلافاصله تصمیم را اجرا می‌کنند. آن‌ها اهل تعلل نیستند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های تصمیم‌گیری در DCها:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. عدم وابستگی به نظر جمع، تمرکز بر شواهد</h3>
        <p className="text-gray-800 leading-7">
          نظر اکثریت، اگر منطقی نباشد، برای آن‌ها اهمیتی ندارد. تحلیل و دلایل برایشان مهم‌تر از همراهی جمع است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تصمیم‌های مستقل، اما با مسئولیت‌پذیری بالا</h3>
        <p className="text-gray-800 leading-7">
          DCها معمولاً تصمیمات کلیدی را خودشان می‌گیرند و شخصاً پای نتایج آن می‌ایستند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های تصمیم‌گیری در DCها:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. استفاده از سناریوهای مختلف برای پیش‌بینی نتیجه</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها چند سناریو طراحی می‌کنند: اگر این تصمیم را بگیرم، چه پیامدی دارد؟ راه‌حل جایگزین چیست؟ این نوع نگاه باعث کاهش ریسک تصمیماتشان می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. تمایل به تصمیمات ساختاریافته و غیرمبهم</h3>
        <p className="text-gray-800 leading-7">
          تصمیماتی که چارچوب یا فرآیند مشخص ندارند، برایشان آزاردهنده است. دوست دارند هر تصمیم بخشی از یک سیستم کامل باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت تصمیم‌گیری در DC"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>دوراندیشی بالا</li>
          <li>ترکیب منطق با سرعت اجرا</li>
          <li>رهایی از احساسات یا فشار بیرونی در تصمیم‌ها</li>
          <li>استفاده از داده‌محوری برای کاهش اشتباه</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های احتمالی:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>ریسک کم انعطاف بودن: اگر شرایط خارج از چارچوب باشد، ممکن است سردرگم شوند یا واکنش شدیدی نشان دهند.</li>
          <li>وسواس در کامل بودن داده‌ها: گاهی در انتظار رسیدن اطلاعات کامل، اجرای تصمیم به تأخیر می‌افتد.</li>
          <li>تمایل به حذف نظرات احساسی یا غیرمنطقی دیگران: ممکن است ارتباطات انسانی را در فرایند تصمیم‌گیری کم‌رنگ ببینند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          تصور کنید مدیر   DCبرای استخدام یک کارشناس تصمیم می‌گیرد. او ابتدا رزومه‌ها را تحلیل می‌کند، سوابق کاری را دقیق بررسی می‌کند، مصاحبه ساختاریافته برگزار می‌کند و با وجود پیشنهاد دیگران، فقط فردی را انتخاب می‌کند که بر اساس داده‌های تحلیلی، بالاترین تطابق را دارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Margin Call" 2011   درخواست نهایی
          فیلمی با تمرکز بر تصمیم‌گیری‌های پیچیده در بحران مالی، جایی که تحلیل داده‌ها و تفکر منطقی، بر احساسات و فشار جمعی غلبه می‌کند. یک نمونه عالی از سبک تصمیم‌گیری افراد  DC .
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد DC"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCبه طور ذاتی منظم، مقتدر، تحلیل‌گر و نتیجه‌گرا هستند. اما همین ویژگی‌ها اگر بیش از حد پررنگ یا بدون تعدیل باقی بمانند، می‌توانند به فشار زیاد، تعارض با دیگران و خستگی روانی منجر شوند. در این بخش پیشنهاداتی برای تقویت عملکرد، کاهش تعارضات و افزایش رضایت شغلی و اجتماعی این افراد ارائه می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تعادل بین سرعت و تعامل انسانی</h3>
        <p className="text-gray-800 leading-7">
          گرچه دوست دارید تصمیم‌ها سریع گرفته شوند و نتایج سریع دیده شوند، اما همه افراد مثل شما فکر نمی‌کنند.
          توصیه: برای اجرای بهتر تصمیم‌ها، تعامل و همدلی را تمرین کنید. شنیدن دیدگاه‌های تیم گاهی مسیر را بهبود می‌دهد، نه کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. افزایش تحمل نسبت به خطا و نقص دیگران</h3>
        <p className="text-gray-800 leading-7">
          کمال‌گرایی شما عالی است، ولی دیگران ممکن است استانداردهای پایین‌تری داشته باشند.
          توصیه: به‌جای تمرکز بر سرزنش، انرژی‌تان را روی آموزش، اصلاح مسیر و ایجاد سیستم‌های بازخورد موثر متمرکز کنید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تمرین تفویض اختیار مؤثر</h3>
        <p className="text-gray-800 leading-7">
          شما تمایل دارید خودتان همه چیز را کنترل کنید، اما این باعث کاهش بهره‌وری و خستگی شما می‌شود.
          توصیه: افراد قابل اعتماد را شناسایی کنید، کارها را واگذار کرده و فقط روی ارزیابی خروجی تمرکز کنید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. شفاف‌سازی احساسات در روابط انسانی</h3>
        <p className="text-gray-800 leading-7">
          ممکن است دیگران شما را خشک، بی‌احساس یا بیش از حد منطقی تلقی کنند.
          توصیه: گاهی کافی است بگویید "می‌فهمم چی می‌گی" یا "از کارت ممنونم". این جملات ساده، تعاملات شما را انسانی‌تر و گرم‌تر می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. انعطاف در برابر مسیرهای غیرمستقیم رسیدن به هدف</h3>
        <p className="text-gray-800 leading-7">
          اگر راه A  به نتیجه نمی‌رسد، شاید راه B  که کمتر تحلیل‌شده است نیز موثر باشد.
          توصیه: مسیرهای جایگزین را با ذهن باز بشنوید، ارزیابی کنید و از تغییر نترسید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. مدیریت فشار درونی برای نتیجه کامل</h3>
        <p className="text-gray-800 leading-7">
          میل شما به بهترین بودن قابل ستایش است، اما همیشه لازم نیست ۱۰۰ درصد خروجی بگیرید.
          توصیه: گاهی "خوب به‌موقع" بهتر از "عالی دیرهنگام" است. اصل بهره‌وری را بر اصل بی‌نقص بودن ترجیح دهید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. تمرین درک دیدگاه‌های احساسی و شهودی</h3>
        <p className="text-gray-800 leading-7">
          نه‌تنها داده و منطق، بلکه احساسات نیز می‌توانند نشانه‌های مهمی باشند.
          توصیه: در کنار تحلیل، سعی کنید توجه کنید که تصمیم شما چه حس و تأثیری بر دیگران دارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فرد   DCدر جلسه تیمی، به جای تمرکز صرف بر گزارش مالی، از اعضای تیم می‌پرسد: «چه چیزی باعث شده احساس کنید این پروژه دشوار است؟» این یک حرکت کوچک اما بسیار مؤثر برای افزایش تعامل انسانی و کار تیمی است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          Whiplash شلاق، فیلمی که درباره مرز باریک بین بلندپروازی، سخت‌کوشی و فشار بیش‌ازحد بر خود و دیگران است.    DCها می‌توانند از این فیلم درس‌های مهمی بگیرند.
        </p>
        <p className="text-gray-800 leading-7">
          "Apollo 13" 1995
          فیلمی که شخصیت فرمانده ماموریت، با ترکیب تحلیل، قدرت تصمیم‌گیری و درک انسانی، تیم را از بحران عبور می‌دهد. نمونه‌ای خوب برای یادگیری تعادل بین کنترل و همدلی در عملکرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت افراد با الگوی رفتاری DC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری  DC، به‌واسطه‌ی ترکیب منحصربه‌فردی از قدرت تصمیم‌گیری، اراده بالا، دقت و تحلیل‌گری، پتانسیل بالایی برای رسیدن به موفقیت‌های چشمگیر دارند. با این حال، موفقیت آن‌ها وقتی پایدار، متوازن و رضایت‌بخش خواهد بود که بتوانند برخی مهارت‌های مکمل را نیز در کنار توانمندی‌های اصلی‌شان تقویت کنند.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه، مهم‌ترین عوامل موفقیت پایدار برای این تیپ شخصیتی را مرور می‌کنیم:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت افراد با الگوی رفتاری DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. توانایی ساخت ساختارهای حرفه‌ای</h3>
        <p className="text-gray-800 leading-7">
          DCها وقتی در موقعیت‌هایی قرار بگیرند که بتوانند سیستم بسازند، فرآیندها را اصلاح کنند و ساختارهای ناکارآمد را بهینه کنند، به شکوفایی می‌رسند.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: در نقش‌هایی باشید که اختیار طراحی، بازطراحی یا ارزیابی سیستم‌ها را دارید. از مشاغل بدون چارچوب و پرابهام دوری کنید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. ترکیب "سرعت عمل" با "تحلیل داده‌محور"</h3>
        <p className="text-gray-800 leading-7">
          یکی از نقاط قوت   DCاین است که تصمیم‌های سریع، اما نه سطحی، می‌گیرند. این ترکیب را باید نگه دارند و تقویت کنند.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: حفظ تعادل بین "تحلیل کافی" و "اقدام سریع" رمز برنده‌شدن شما در رقابت‌های شغلی و فردی است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت افراد با الگوی رفتاری DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تقویت ارتباط انسانی و رهبری نرم</h3>
        <p className="text-gray-800 leading-7">
          یکی از چالش‌های افراد   DCدر مسیر رشد، تعامل مؤثر با دیگران است. موفق‌ترین DC  ها آن‌هایی هستند که در کنار قاطعیت، همدلی و شنیدن فعال را هم یاد گرفته‌اند.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: تقویت هوش هیجانی، گوش دادن، دادن بازخورد انسانی، در کنار استانداردهای فنی.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. توانایی "نه گفتن" به وسواس بیش از حد روی جزئیات</h3>
        <p className="text-gray-800 leading-7">
          گرچه دقت بالا ارزشمند است، اما زمانی که سرعت یا تصمیم‌گیری را فلج کند، کارآمدی شما را کاهش می‌دهد.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: یاد بگیرید کی و کجا باید «دقیق» باشید، و کی «کافی بودن» ارزشمندتر از کمال است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. جذب تیم‌های مکمل نه مشابه</h3>
        <p className="text-gray-800 leading-7">
          افراد   DCمعمولاً دوست دارند با افراد دقیق، منطقی و منضبط کار کنند. اما برای موفقیت بزرگ، به افراد خلاق I، اجتماعی S  یا نوآور نیز نیاز دارند.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: تیم‌هایی بسازید که تیپ‌های رفتاری مکمل در آن‌ها حضور داشته باشند، نه فقط شبیه به خودتان.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت افراد با الگوی رفتاری DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. تمرین رهایی از کنترل دائمی</h3>
        <p className="text-gray-800 leading-7">
          گاهی اوقات برای توسعه، لازم است کنترل را واگذار کنید و به رشد دیگران اعتماد کنید. اگر همه‌چیز را بخواهید شخصاً اجرا کنید، در سطح مدیریت کلان نمی‌مانید.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: تفویض، مربی‌گری و اعتماد به دیگران را تمرین کنید تا ظرفیت‌های بزرگ‌تری آزاد شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. تغییر را به‌عنوان یک فرصت بپذیرید، نه تهدید</h3>
        <p className="text-gray-800 leading-7">
          برخی  DCها به‌دلیل علاقه به کنترل، از تغییرات ناگهانی ناراحت می‌شوند. اما موفقیت پایدار آن‌ها در پذیرش تغییر و هدایت آن نهفته است.
        </p>
        <p className="italic text-gray-700">
          رمز موفقیت: به‌جای مقاومت در برابر تغییر، ابزار و بینش مدیریت تغییر را بیاموزید و از آن استفاده کنید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          مدیری با تیپ  DC، وقتی در یک شرکت تکنولوژی، به‌جای تمرکز صرف بر کنترل تیم، شروع به آموزش اعضا، واگذاری مسئولیت و تقویت فرهنگ سازمانی کرد، توانست از سطح مدیر میانی به سطح راهبر سازمانی ارتقاء پیدا کند.
        </p>
        <p className="text-gray-800 leading-7">
          "Lincoln" 2012
          شخصیت آبراهام لینکلن در این فیلم، ترکیبی از قدرت تصمیم‌گیری، تحلیل سیاسی عمیق، درک شرایط، و تعامل انسانی است. الگوی بسیار خوبی برای یک   DCتوسعه‌یافته.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ DC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری   DCمعمولاً از لحاظ رفتاری قدرتمند، دقیق، ساختاریافته و نتیجه‌محور هستند. اما برای عملکرد متوازن‌تر و ارتباطات مؤثرتر، لازم است ویژگی‌های سه لایه رفتاری دیگر I ،  S ، C  را نیز تا حدی در خود تقویت یا متعادل کنند. در این بخش، نحوه‌ی تقویت هر یک از این لایه‌ها را به تفکیک بررسی می‌کنیم:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="1. تقویت لایه I روابط اجتماعی و نفوذ کلامی"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCگاهی در ارتباطات انسانی سرد، خشک و صرفاً منطقی جلوه می‌کنند. تقویت لایه I  کمک می‌کند تا بتوانند در محیط‌های اجتماعی، کاریزما و نفوذ بیشتری داشته باشند.
        </p>
        <p className="text-gray-800 leading-7">
          تمرین‌ها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>استفاده بیشتر از جملات دوستانه، مثبت و تشویق‌کننده در گفتگوها</li>
          <li>قدردانی کلامی و عاطفی از عملکرد دیگران، نه فقط فنی و منطقی</li>
          <li>مشارکت در جلسات تعاملی، رویدادهای تیمی، بازی‌های گروهی یا تمرین‌های گروه‌محور</li>
          <li>دیدن فیلم‌هایی با محوریت روابط انسانی مانند: “ The Intern” 2015 –  کارآموز،  برای درک عمق رابطه بین حرفه‌ای‌گری و مهربانی انسانی</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="2. تقویت لایه S صبوری، پایداری، همدلی"
      >
        <p className="text-gray-800 leading-7">
          لایه S  به افراد کمک می‌کند که با صبر، پایداری، شنیدن فعال و همراهی در کنار دیگران بمانند. برای  DCهایی که سرعت و کنترل بالا دارند، این ویژگی یک مکمل ضروری برای تعادل در تیم و زندگی شخصی است.
        </p>
        <p className="text-gray-800 leading-7">
          تمرین‌ها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>تمرین گوش دادن بدون قضاوت و قطع کردن صحبت دیگران</li>
          <li>پرسیدن جمله‌هایی مانند: "به نظر تو چطور میشه اینو بهتر انجام داد؟"</li>
          <li>پذیرش اینکه بعضی‌ افراد نیاز به زمان بیشتر برای تطبیق یا پاسخ دارند</li>
          <li>دیدن فیلم‌هایی درباره همدلی و وفاداری مثل: “A Beautiful Day in the Neighborhood” 2019 روزی زیبا در محله</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="3. تعدیل لایه D برای اجتناب از تسلط بیش‌ازحد"
      >
        <p className="text-gray-800 leading-7">
          گاهی D  زیاد در افراد   DCمنجر به استبداد، فشار روانی بر تیم و سخت‌گیری افراطی می‌شود.
        </p>
        <p className="text-gray-800 leading-7">
          تمرین‌ها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>کنترل خشم و زبان بدن قاطع در زمان فشار</li>
          <li>پرسیدن نظرات قبل از تصمیم نهایی: "دوستان فکر می‌کنید گزینه بهتری هست؟"</li>
          <li>تمرین نه گفتن به مداخله‌های غیرضروری و پرهیز از کنترل دائمی</li>
          <li>استفاده از جملات تعدیل‌گر مثل: "بیایید با هم بررسی کنیم..." به جای "من تصمیم گرفتم..."</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="4. تعدیل وسواس C برای رهایی از کمال‌گرایی فلج‌کننده"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCممکن است گاهی به‌قدری غرق در تحلیل و بررسی شوند که زمان یا موقعیت اجرا را از دست بدهند.
        </p>
        <p className="text-gray-800 leading-7">
          تمرین‌ها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>استفاده از اصل "80 درصد کافی است" برای پروژه‌های غیرحیاتی</li>
          <li>واگذاری جزئیات به افراد دقیق‌تر  High C  یا CS  و تمرکز روی تصویر کلان</li>
          <li>ایجاد بازه‌های زمانی محدود برای تصمیم‌گیری</li>
          <li>دیدن فیلم‌هایی که نشان می‌دهند "انعطاف بهتر از دقت خشک است"، مثل: “Moneyball” 2011 –  درباره تصمیم‌گیری سریع در دل داده‌های ناقص</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="جملات کلیدی برای تقویت و تعادل:"
      >
        <p className="italic text-gray-700">
          «نظر شما هم برام مهمه.»
        </p>
        <p className="italic text-gray-700">
          «بیایید اول حرف‌هاتون رو بشنوم بعد تحلیل کنیم.»
        </p>
        <p className="italic text-gray-700">
          «همیشه همه‌چیز طبق برنامه پیش نمی‌ره، اشکالی نداره.»
        </p>
        <p className="italic text-gray-700">
          «اگر اشتباهی بود، بریم ببینیم چی یاد گرفتیم.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی DC"
      >
        <p className="text-gray-800 leading-7">
          برای افزایش اثربخشی فردی، حرفه‌ای و تعادل رفتاری
          افراد   DCبه‌طور طبیعی در مهارت‌هایی مثل تحلیل، برنامه‌ریزی استراتژیک، کنترل و تصمیم‌گیری قاطع قوی هستند. اما برای عملکرد متوازن‌تر، رهبری انسانی‌تر و موفقیت در دنیای پیچیده امروز، نیاز به توسعه مجموعه‌ای از مهارت‌های مکمل دارند.
        </p>
        <p className="text-gray-800 leading-7">
          در این بخش، مهم‌ترین مهارت‌های کلیدی را معرفی می‌کنیم:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. هوش هیجانی</h3>
        <p className="text-gray-800 leading-7">
          برای افزایش همدلی، کنترل خشم، و شناخت احساسات خود و دیگران
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>مهارت در تشخیص محرک‌های احساسی در ارتباطات</li>
          <li>یادگیری تکنیک‌های کنترل واکنش‌های ناگهانی</li>
          <li>افزایش آگاهی نسبت به تأثیر رفتار و کلام بر دیگران</li>
        </ul>
        <p className="text-gray-800 leading-7">
          منبع پیشنهادی:
          کتاب «هوش هیجانی» اثر دانیل گلمن
          فیلم: Inside Out  – انیمیشن آموزنده درباره درک و مدیریت هیجان
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. مدیریت تیم و رهبری متعادل</h3>
        <p className="text-gray-800 leading-7">
          برای داشتن نفوذ واقعی در تیم‌های چندبعدی
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>تفویض اختیار، مربی‌گری و ایجاد حس اعتماد</li>
          <li>هدایت تیم با مشارکت نه سلطه</li>
          <li>شفاف‌سازی مأموریت و نقش‌ها</li>
        </ul>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
          Remember the Titans  درباره رهبری انسانی و همراه‌ساز
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. حل مسئله و تصمیم‌گیری در شرایط عدم قطعیت</h3>
        <p className="text-gray-800 leading-7">
          برای زمانی که اطلاعات کامل نیست و باید اقدام کرد
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>طراحی سناریوهای جایگزین</li>
          <li>تحمل ابهام و سرعت در جمع‌بندی</li>
          <li>تحلیل ریسک در زمان محدود</li>
        </ul>
        <p className="text-gray-800 leading-7">
          ابزار: مدل‌های SWOT ، 5 Why ، ماتریس تصمیم‌گیری
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. مهارت‌های ارتباطی پیشرفته و گفت‌وگوی مؤثر</h3>
        <p className="text-gray-800 leading-7">
          برای تأثیرگذاری در کنار قاطعیت
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>بیان شفاف اما غیرتهاجمی</li>
          <li>شنیدن فعال، بازخورد دادن سازنده</li>
          <li>استفاده از زبان بدن مثبت</li>
        </ul>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
          The King’s Speech درباره قدرت کلام و اعتماد به نفس
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. مدیریت زمان و اولویت‌بندی چندگانه</h3>
        <p className="text-gray-800 leading-7">
          با توجه به روحیه نتیجه‌گرایی  DCها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>تفکیک بین کارهای مهم و فوری</li>
          <li>حذف کمال‌گرایی در کارهای کم‌اهمیت</li>
          <li>ابزارهایی مانند Eisenhower Matrix  یا Pomodoro</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. توسعه تفکر استراتژیک و سیستمی</h3>
        <p className="text-gray-800 leading-7">
          برای دیدن تصویر کلان و ساخت سیستم‌های پایدار
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>درک روابط علت و معلولی</li>
          <li>ارزیابی چرخه‌های سازمانی</li>
          <li>طراحی فرآیندها و KPI های هدف‌محور</li>
        </ul>
        <p className="text-gray-800 leading-7">
          کتاب: Strategy Safari  هنری مینتزبرگ
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. توسعه مهارت‌های نرم‌افزاری مکمل شخصیت تحلیلی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>Excel پیشرفته، نرم‌افزارهای مدیریت پروژه مثل Trello، Asana، Jira</li>
          <li>ابزارهای تحلیل داده Power BI ، Tableau</li>
          <li>اتوماسیون تصمیم‌ها با ابزارهای دیجیتال</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. آموزش مهارت‌های خودشناسی و روانشناسی رفتاری</h3>
        <p className="text-gray-800 leading-7">
          برای رشد فردی و شناخت سبک‌های رفتاری دیگران
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>DISC، MBTI، هالند، نئو</li>
          <li>تحلیل رفتار متقابل Transactional Analysis</li>
          <li>شناخت سوگیری‌های ذهنی و شناختی</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی DC"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری   DCبه‌دنبال مشاغلی هستند که در آن‌ها بتوانند کنترل، تحلیل، تصمیم‌گیری مستقل، ساختاردهی، و مدیریت منابع و فرایندها را در اختیار داشته باشند. آن‌ها از کار در محیط‌هایی که استاندارد، خروجی و اثرگذاری ملموس دارند لذت می‌برند.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه، فهرستی از مشاغل متناسب با این الگو همراه با تحلیل کوتاه هرکدام ارائه می‌شود:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مدیر پروژه‌های صنعتی یا مهندسی</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          ترکیب نیاز به تصمیم‌گیری سریع، تحلیل دقیق منابع و کنترل اجرایی برای  DCها بسیار مطلوب است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تحلیل‌گر سیستم‌های اطلاعاتی IT Analyst</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          تسلط بر داده‌ها، ساختاردهی سیستم‌ها و طراحی راه‌حل‌های تحلیلی همسو با ویژگی‌های فرد   DCاست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. مدیر کیفیت یا تضمین کیفیت Quality Manager</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          افراد   DCوسواس بالایی روی دقت و استاندارد دارند و در این حوزه درخشان عمل می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. مشاور مدیریت یا استراتژی</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          این افراد هم با تحلیل ساختارهای موجود، هم با پیشنهاد سیستم‌های جایگزین قدرت تأثیرگذاری بالایی دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. سرپرست واحد تولید یا عملیات</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          کنترل منابع، بازدهی، برنامه‌ریزی دقیق و نظارت دائمی بر فرایندها، همگی برای  DCها جذاب و چالشی‌اند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. تحلیل‌گر مالی یا حسابرسی ارشد</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          افراد   DCعلاقه‌مند به ساختار، دقت عددی و تحلیل داده‌های مالی هستند و با وظایف این شغل همخوانی دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مدیر منابع انسانی داده‌محور HR Analytics</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          در نقش‌هایی که منابع انسانی را با تحلیل، شاخص‌های عملکرد KPI  و داده‌های رفتاری ترکیب می‌کنند،  DCها می‌درخشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. افسر یا فرمانده نظامی/امنیتی</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          انضباط بالا، تحلیل وضعیت، اجرای دستور، و ساختار سلسله‌مراتبی مورد پسند  DCهاست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. قاضی یا بازپرس قضایی</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          علاقه به نظم، تحلیل منطقی، عدالت ساختاریافته و استقلال در تصمیم‌گیری،  DCها را به گزینه‌های عالی برای این مشاغل بدل می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. کارآفرین حوزه مهندسی یا داده‌محور</h3>
        <p className="text-gray-800 leading-7">
          چرا مناسب است؟
          آن‌ها دوست دارند ایده‌ای را تحلیل کنند، ساختارش بدهند، تیم جمع کنند و خودشان آن را تا نتیجه پیش ببرند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی DC"
      >
        <p className="text-gray-800 leading-7">
          یادآوری مهم:
          با وجود همه‌ی این پیشنهادات، در انتخاب مسیر شغلی باید موارد زیر نیز لحاظ شود:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>نتایج آزمون رغبت شغلی هالند</li>
          <li>کشش بازار کار</li>
          <li>سطح تحصیلات و مهارت‌های تخصصی</li>
          <li>علاقه‌مندی‌های شخصی و تجربه‌های پیشین</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="همسر مناسب برای DC و نحوه ارتباط مؤثر با او"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای تیپ رفتاری  DC، ترکیبی از شخصیت‌های «بااراده، نتیجه‌گرا، تحلیلی و ساختارمند» هستند. در روابط زناشویی نیز، خواهان ثبات، منطق، احترام متقابل، استقلال شخصی و نظم رفتاری هستند. ارتباط با آن‌ها می‌تواند بسیار امن و قابل پیش‌بینی باشد، به‌شرطی که طرف مقابل اصولی را رعایت کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های مناسب برای همسر فرد DC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. اعتماد به نفس و استقلال رأی</h3>
        <p className="text-gray-800 leading-7">
          افراد   DCاز همسری که منفعل یا وابسته باشد خسته می‌شوند. آن‌ها به شریک زندگی‌ای احترام می‌گذارند که خودش فکر می‌کند، تصمیم می‌گیرد و برنامه دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. توانایی در گفت‌وگوی منطقی</h3>
        <p className="text-gray-800 leading-7">
          اهل بحث‌های سطحی یا بازی‌های ذهنی نیستند. همسری که صریح، مودب و روشن گفت‌وگو کند، برای آن‌ها جذاب است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. پایبندی به نظم، ساختار و مسئولیت‌پذیری</h3>
        <p className="text-gray-800 leading-7">
          بی‌نظمی، بی‌برنامگی یا بی‌تعهدی برای  DCها زنگ خطر است. همسری که در زندگی روزمره منظم، متعهد و مسئول باشد، احساس اعتماد عمیق در آن‌ها ایجاد می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. درک نیاز آن‌ها به فضا و استقلال</h3>
        <p className="text-gray-800 leading-7">
          DCها گاهی نیاز به تنهایی دارند. همسری که این فضا را با سوءتفاهم یا وابستگی بیش‌ازحد خراب نکند، برایشان طلاست.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد DC باید بداند"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. محبت DCها رفتاری است نه کلامی</h3>
        <p className="text-gray-800 leading-7">
          ممکن است زیاد ابراز احساس نکنند، اما با کار، مراقبت و مسئولیت عشق خود را نشان می‌دهند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دستور نمی‌دهند، طراحی می‌کنند</h3>
        <p className="text-gray-800 leading-7">
          اگر چیزی را پیشنهاد می‌دهند، اغلب با تحلیل و منطق است. واکنش احساسی سریع نداشته باشید، بلکه دلایلشان را بشنوید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. کنترل‌گر نیستند، فقط می‌خواهند کار درست پیش برود</h3>
        <p className="text-gray-800 leading-7">
          اگر در کارها سخت‌گیر هستند، از سر علاقه به نظم و نتیجه است. به‌جای مقابله، وارد مذاکره شوید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. از درگیری بی‌نتیجه پرهیز می‌کنند</h3>
        <p className="text-gray-800 leading-7">
          بحث‌های بی‌سرانجام آن‌ها را آزار می‌دهد. بهتر است با ساختار و چارچوب وارد گفت‌وگو شوید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. همدلی را یاد بگیرد، حتی اگر منطقی نیست</h3>
        <p className="text-gray-800 leading-7">
          گاهی شریک زندگی‌تان فقط می‌خواهد شنیده شود، نه حل شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. کاهش زبان قاطع و دستوری</h3>
        <p className="text-gray-800 leading-7">
          نحوه بیان خواسته گاهی از خود خواسته مهم‌تر است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. وقت‌گذرانی بدون هدف هم مفید است</h3>
        <p className="text-gray-800 leading-7">
          لازم نیست همه چیز کارآمد باشد. با همسر گاهی فقط «باشید»، نه فقط «انجام دهید».
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. ابراز احساسات را تمرین کنید</h3>
        <p className="text-gray-800 leading-7">
          کلمات محبت‌آمیز، لمس، و توجه لحظه‌ای، سوخت رابطه‌اند. یاد بگیرید چطور احساسات را ولو اندک، بروز دهید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "The Theory of Everything" 2014
          روایتی از زندگی استیون هاوکینگ، نابغه‌ای با شخصیت تحلیلی، و نقش همسر فهیم و حامی او در حفظ و رشد رابطه‌ای پیچیده.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین DC با فرزندان"
      >
        <p className="text-gray-800 leading-7">
          افراد   DCدر نقش پدر یا مادر، معمولاً بااراده، منظم، دقیق، مسئولیت‌پذیر و آینده‌نگر هستند. آن‌ها دوست دارند فرزندانی تربیت کنند که مستقل، هدفمند، وقت‌شناس، و موفق باشند. اما اگر مراقب نباشند، ممکن است به‌جای «هدایت»، به‌سمت «کنترل‌گری» یا سخت‌گیری بیش‌ازحد بروند.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه، راهکارهایی برای برقراری رابطه مؤثر والدین   DCبا فرزندان ارائه می‌شود:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین DC با فرزندان"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. توازن بین نظم و محبت را حفظ کنید</h3>
        <p className="text-gray-800 leading-7">
          فرزند شما انسان است، نه پروژه!
          توجه و محبت بدون قید و شرط نه فقط در ازای عملکرد خوب از نیازهای بنیادین اوست.
          مثال: اگر فرزندتان در امتحان نمره خوبی نگرفت، قبل از ارائه راه‌حل، بپرسید: «الان چه حسی داری؟» نه اینکه بلافاصله بگویید: «باید بیشتر می‌خوندی!»
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. به تفاوت‌های شخصیتی احترام بگذارید</h3>
        <p className="text-gray-800 leading-7">
          اگر فرزند شما آرام، احساسی، هنرمند یا اجتماعی است، سعی نکنید او را کپی خودتان کنید.
          به تیپ رفتاری DISC  او توجه کنید و براساس آن، ارتباط بسازید.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
          Dead Poets Society 1989  انجمن شاعران مرده درباره‌ی تفاوت نسل‌ها، نیاز به آزادی و رابطه معنادار بین والد و فرزند
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. کنترل را به «هدایت» تبدیل کنید</h3>
        <p className="text-gray-800 leading-7">
          راهنمایی کنید، اما اجازه دهید فرزندتان انتخاب کند.
          کنترل زیاد، پنهان‌کاری و طغیان را به‌دنبال دارد.
          تمرین:
          به‌جای اینکه بگویید: «نباید فلان کارو بکنی»، بپرسید: «فکر می‌کنی این تصمیم چه پیامدی داره؟»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین DC با فرزندان"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. فرصت اشتباه کردن بدهید</h3>
        <p className="text-gray-800 leading-7">
          افراد   DCبه‌دلیل وسواس بالا از اشتباه می‌ترسند، اما فرزند شما باید یاد بگیرد از اشتباه درس بگیرد، نه اینکه از آن بترسد.
          توصیه:
          وقتی اشتباهی رخ داد، به‌جای سرزنش، آن را به فرصتی برای گفتگو تبدیل کنید:
          «چی یاد گرفتی؟ دفعه بعد چی کار می‌تونی بکنی؟»
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. در رابطه‌تان انعطاف داشته باشید</h3>
        <p className="text-gray-800 leading-7">
          قرار نیست همیشه منطقی باشید. گاهی کافی است فقط در کنار فرزندتان باشید.
          تمرین ساده:
          هفته‌ای یک بار، فقط به‌عنوان یک همراه، نه والد، کنار فرزندتان بنشینید و هر کاری که او دوست دارد با او انجام دهید  حتی اگر به نظر شما «بی‌هدف» است.
        </p>
        <p className="text-gray-800 leading-7">
          جمله‌های سازنده‌ای که والد   DCمی‌تواند استفاده کند:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>«از نظر من این منطقیه، ولی دوست دارم نظر تو رو هم بشنوم.»</li>
          <li>«مهم‌تر از نتیجه، اینه که یاد بگیری چطور مسیرتو بسازی.»</li>
          <li>«می‌دونم شکست خوردی، ولی این یعنی شجاعت داشتی که تلاش کنی.»</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد DC ارتباط مؤثر برقرار کنیم؟"
      >
        <p className="text-gray-800 leading-7">
          والدین   DCمعمولاً افرادی سخت‌کوش، هدفمند، قانون‌مند و آینده‌نگر هستند. آن‌ها برای خانواده‌شان امنیت، نظم و مسیر روشن می‌خواهند. اما گاهی این میل به موفقیت و ساختار ممکن است باعث شود فرزندانشان احساس فشار، بی‌توجهی احساسی یا سخت‌گیری بیش‌ازحد داشته باشند.
        </p>
        <p className="text-gray-800 leading-7">
          در این بخش، به فرزندان کمک می‌کنیم تا یاد بگیرند چگونه با پدر یا مادر DC خود بهتر ارتباط بگیرند، بدون آن‌که استقلال یا احترام متقابل خدشه‌دار شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد DC ارتباط مؤثر برقرار کنیم؟"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. با منطق و شواهد صحبت کنید</h3>
        <p className="text-gray-800 leading-7">
          والد   DCبه داده و تحلیل علاقه دارد. اگر خواسته‌ای دارید، سعی کنید دلیل منطقی برایش بیاورید.
          مثال:
          به‌جای اینکه بگویید: «همه می‌رن اردو، منم می‌خوام برم!»
          بگویید: «این اردو آموزشی‌ـه، تجربه‌ای خوبه و مدرسه مسئولشه. گزارش هم باید بنویسیم.»
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. احترام به قوانین خانه را جدی بگیرید</h3>
        <p className="text-gray-800 leading-7">
          نظم و چارچوب از ارزش‌های حیاتی برای والد   DCاست. با بی‌نظمی یا بی‌مسئولیتی، ارتباطتان سرد و سخت می‌شود.
          توصیه:
          قبل از اعتراض به قانون، پیشنهاد اصلاح یا مذاکره محترمانه بدهید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ابراز احساسات را بیاموزید، حتی اگر سخت است</h3>
        <p className="text-gray-800 leading-7">
          والد   DCممکن است خودش در ابراز محبت ضعیف باشد، ولی وقتی فرزندش صادقانه احساساتش را بیان می‌کند، نرم‌تر می‌شود.
          تمرین: جملاتی مثل «وقتی باهام حرف نمی‌زنی، احساس تنهایی می‌کنم» اثرگذارتر از قهر کردن یا سکوت است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد DC ارتباط مؤثر برقرار کنیم؟"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. در زمان مناسب گفت‌وگو کنید</h3>
        <p className="text-gray-800 leading-7">
          وقتی والد   DCدرگیر کاری است، خسته یا تحت فشار است، زمان مناسبی برای گفت‌وگو نیست. آن‌ها به تمرکز اهمیت می‌دهند.
          تمرین:
          ساعت مشخصی را برای صحبت درباره دغدغه‌ها تعیین کنید. به‌عنوان مثال: «می‌شه شب بعد از شام ۱۰ دقیقه باهم صحبت کنیم؟»
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. قدرشناسی را فراموش نکنید</h3>
        <p className="text-gray-800 leading-7">
          والد   DCممکن است محبتش را از طریق فراهم کردن امکانات، نظم دادن به زندگی یا پیگیری آموزش شما نشان دهد. دیدن و قدردانی از این تلاش‌ها به رابطه عمق می‌دهد.
          مثال:
          «می‌دونم خیلی کار می‌کنی که ما راحت باشیم. ممنونم بابت زحماتت.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          “The Pursuit of Happyness” 2006
          روایتی از تلاش یک پدر منطقی، ساختارمند و مصمم برای موفقیت فرزندش در شرایط دشوار  و رابطه احساسی پنهان‌شده در پشت سخت‌گیری‌هایش.
        </p>
      </Page>
    </>
  )
}

export default DC
